import React, { useEffect } from 'react';
import { StickyAlertBar } from '../components/StickyAlertBar';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { ResultsGallery } from '../components/ResultsGallery';
import { PricingOffer } from '../components/PricingOffer';
import { BonusesSection } from '../components/BonusesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { CTASection } from '../components/CTASection';
import { initMetaPixel } from '../utils/metaPixel';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full min-h-screen bg-cream" data-id="element-195">
      <StickyAlertBar data-id="element-196" />
      <HeroSection data-id="element-197" />
      <ProblemSection data-id="element-198" />
      <SolutionSection data-id="element-199" />
      <BenefitsSection data-id="element-200" />
      <ResultsGallery data-id="element-201" />
      <PricingOffer data-id="element-202" />
      <BonusesSection data-id="element-203" />
      <CTASection headline="¿Lista para empezar a crear?" subtext="Más de 3.700 tejedoras ya dieron el primer paso" buttonText="QUIERO MI EBOOK AHORA" data-id="element-204" />
      <TestimonialsSection data-id="element-205" />
      <FAQSection data-id="element-206" />
      <CTASection headline="Tu momento es ahora 🧶" subtext="Aprovechá la oferta antes de que termine" buttonText="COMPRAR AHORA" data-id="element-207" />
      <Footer data-id="element-208" />
    </div>;
}